import { graphql } from '../gql'; // Ensure this is properly defined
import { useQuery } from '@apollo/client';

// Define the GraphQL query
export const GET_BDM_REGION = graphql(`
  query bdmTerritories($filters: BdmTerritoryFilterInput) {
    bdmTerritories(filters: $filters) {
      edges {
        node {
          uuid
          name
        }
      }
    }
  }
`);

export function useGetBDMRegion() {
  const { loading, error, data } = useQuery(GET_BDM_REGION, {});

  return { loading, error, data };
}
